// Portal sessions are stored under their own keys, namespaced by portal slug.
// A staff user and a client can be signed in in the same browser without
// clobbering each other, and opening two tenants' portals keeps two sessions.
const portalKey = (slug: string, name: string) => `portal:${slug}:${name}`;

export interface PortalTokens {
  access: string;
  refresh: string;
}

export function getPortalTokens(slug: string): PortalTokens {
  return {
    access: localStorage.getItem(portalKey(slug, 'accessToken')) || '',
    refresh: localStorage.getItem(portalKey(slug, 'refreshToken')) || '',
  };
}

export function setPortalTokens(slug: string, tokens: { access: string; refresh?: string }) {
  if (tokens.access) localStorage.setItem(portalKey(slug, 'accessToken'), tokens.access);
  if (tokens.refresh) localStorage.setItem(portalKey(slug, 'refreshToken'), tokens.refresh);
}

export function clearPortalTokens(slug: string) {
  localStorage.removeItem(portalKey(slug, 'accessToken'));
  localStorage.removeItem(portalKey(slug, 'refreshToken'));
}

export function getPortalTenantId(slug: string): string {
  return localStorage.getItem(portalKey(slug, 'tenantId')) || '';
}

export function setPortalTenantId(slug: string, tenantId: string | number) {
  localStorage.setItem(portalKey(slug, 'tenantId'), String(tenantId));
}
